const UtilsService = require('@transfeeradev/api-services/UtilsService');

class Parser {
  constructor(data) {
    this._data = data;
    this._fixCommaSplicedFirstLine();
  }

  getFirstLine() {
    return this._data[0];
  }

  getHeaders() {
    return this._data[1];
  }

  getItems() {
    const headers = this.getHeadersFormatted();

    const rows = this._data.slice(2, this._data.length).filter(d => d && d.length);
    return rows.map(row => {
      return headers.reduce((obj, header, index) => {
        obj[header] = row[index];
        return obj;
      }, {});
    });
  }

  getHeadersFormatted(headers = this.getHeaders()) {
    const IGNORED_WORD = 'opcional';

    return headers.map(header => {
      if (typeof header === 'string') {
        header = header.replace(IGNORED_WORD, '');
        return UtilsService.getOnlyLettersWithoutAccents(UtilsService.removeAccents(header.toLowerCase())).trim();
      }

      return header;
    });
  }

  _fixCommaSplicedFirstLine() {
    const FIRST_PART_OF_LINE = 'Mantenha sempre o cabeçalho original da planilha e esta linha';
    const SECOND_PART_OF_LINE = 'mantendo os titulos e a ordem dos campos';
    const firstLine = this._data[0];

    if (
      firstLine.length === 2 &&
      firstLine[0].trim() === FIRST_PART_OF_LINE &&
      firstLine[1].trim() === SECOND_PART_OF_LINE
    ) {
      firstLine[0] = FIRST_PART_OF_LINE + ', ' + SECOND_PART_OF_LINE;
      firstLine.splice(1, 1);
    }
  }
}

module.exports = Parser;
